import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  ApartmentCreateInterface,
  ApartmentInterface,
  ApartmentsPaginatedRequest,
  SpaceListFilters,
  SpacePaginated,
  SpaceResourcesStatistics,
  SpaceToUpdate,
  TApartmentAuthorizationResult,
  TApartmentOwnerInfo
} from '@simOn/space/information/models';
import { API_URL } from '@simOn/utils/tokens';
import { ModelSweep } from '@simlab/matterport/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApartmentsApiService {
  private readonly http = inject(HttpClient);
  private readonly _apiUrl = inject(API_URL);

  getUserApartments$(): Observable<ApartmentInterface[]> {
    return this.http.get<ApartmentInterface[]>(`${this._apiUrl}/apartments/GetApartments`);
  }

  getUserApartment$(apartmentId?: string): Observable<ApartmentInterface> {
    let header;
    if (apartmentId) {
      header = new HttpHeaders().set('apartmentId', apartmentId);
    }
    return this.http.get<ApartmentInterface>(`${this._apiUrl}/Apartments/GetApartment`, { headers: header });
  }

  getApartmentResourcesStatistics$(apartmentId: string): Observable<SpaceResourcesStatistics> {
    return this.http.get<SpaceResourcesStatistics>(
      `${this._apiUrl}/Apartments/GetApartmentResourcesStatistics?apartmentId=${apartmentId}`
    );
  }

  updateApartment$(apartment: Partial<SpaceToUpdate>): Observable<void> {
    let header;
    if (apartment.id) {
      header = new HttpHeaders().set('apartmentId', apartment.id);
    }
    return this.http.put<void>(`${this._apiUrl}/Apartments/UpdateApartment`, apartment, {
      headers: header
    });
  }

  deleteApartment$(apartmentId?: string): Observable<ApartmentCreateInterface> {
    let header;
    if (apartmentId) {
      header = new HttpHeaders().set('apartmentId', apartmentId);
    }
    return this.http.delete<ApartmentCreateInterface>(`${this._apiUrl}/Apartments/DeleteApartment`, {
      headers: header
    });
  }
  getApartmentsPaginated(filters: Partial<SpaceListFilters>) {
    const body: ApartmentsPaginatedRequest = {
      pageFilter: {
        pageNumber: filters.pageNumber ?? 1,
        pageSize: filters.pageSize ?? 10
      },
      apartmentFilter: {
        name: filters.name ?? null,
        apartmentIds: filters.apartmentIds ?? null,
        workspaceIds: filters.workspaceIds ?? null
      },
      apartmentSort:
        filters.sortBy !== undefined
          ? { sortBy: filters.sortBy as number, isAscending: filters.isAscending ?? true }
          : null
    };
    return this.http.post<SpacePaginated>(`${this._apiUrl}/Apartments/GetApartmentsPaginated`, body);
  }

  getUserApartmentShort$(): Observable<ApartmentInterface> {
    return this.http.get<ApartmentInterface>(`${this._apiUrl}/apartments/GetApartment?FetchRooms=1`);
  }

  createApartment$(apartment: ApartmentCreateInterface): Observable<TApartmentAuthorizationResult> {
    return this.http.post<TApartmentAuthorizationResult>(`${this._apiUrl}/apartments/CreateApartment`, apartment);
  }

  QueryParamsFromObject(object: {}): string {
    let result = '';
    try {
      Object.keys(object).forEach((propertyName) => {
        result += `?${propertyName}=${object[propertyName as keyof object]}`;
      });
    } catch (e) {
      console.error('[ERROR] simlabapiservice.interfaces, error: ', e);
    }
    return result;
  }

  updateScanModelScanPoints$(payload: { scanModelId: string; sweeps: ModelSweep[] }): Observable<void> {
    return this.http.put<void>(`${this._apiUrl}/MatterportModel/UpdateScanModelScanPoints`, payload);
  }

  getApartmentOwnerInfo$(apartmentId?: string): Observable<TApartmentOwnerInfo> {
    let header;
    if (apartmentId) {
      header = new HttpHeaders().set('apartmentId', apartmentId);
    }
    return this.http.get<TApartmentOwnerInfo>(`${this._apiUrl}/Apartments/GetApartmentOwnerInfo`, {
      headers: header
    });
  }
}
